import { Box } from "@mui/material"

const StaffHome = () => {
  return <Box className="staff-content" />
}

export default StaffHome
